import React, { Component } from "react";
import { connect } from "react-redux";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { withRouter } from "../../../../utils/withRouter";
import Loader from "../../../../utils/Loader";
import HeaderWithLogo from "../../../../common_components/header_with_logo";
import AdminDrawer from "../../../../common_components/admin_module_drawer";
import { getAdminVisitorSummaryList_action } from "../../../../actions/admin_module_action/admin_dasboard_action/admin_dashboard_summary_action/admin_dashboard_summary_action";

class VisitorSummary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      categoryWise: [],
      singleAndGroupWise: [],
      dayWise: [],
      countryWise: [],
      top5IndianStates: [],
      top10IndianCity: [],
      purposeOfVisit: [],
      purposeOfSegment: [],
      promoCodeWise: [],
    };
    this.getVisitorSummaryList = this.getVisitorSummaryList.bind(this);
    this.parseColumn = this.parseColumn.bind(this);
    this.renderTable = this.renderTable.bind(this);
  }

  componentDidMount() {
    this.getVisitorSummaryList();
  }

  getVisitorSummaryList() {
    this.setState({ isLoading: true });
    this.props
      .getAdminVisitorSummaryList_action()
      .then((res) => {
        if (res.error != 1) {
          const data = res.data || {};
          console.log("Admin Visitor Summary ------->", data);
          this.setState({
            isLoading: false,
            categoryWise: data.categoryWise || [],
            singleAndGroupWise: data.singleAndGroupWise || [],
            dayWise: data.dayWise || [],
            countryWise: data.countryWise || [],
            top5IndianStates: data.top5IndianStates || [],
            top10IndianCity: data.top10IndianCity || [],
            purposeOfVisit: data.purposeOfVisit || [],
            purposeOfSegment: data.purposeOfSegment || [],
            promoCodeWise: data.promoCodeWise || [],
          });
        } else {
          this.setState({ isLoading: false });
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({ isLoading: false });
      });
  }

  // Parses a numeric column key into { group, sub } for header rendering.
  //
  // Rules (matched in order):
  //   "SinglePaidCount"          → group="Single",             sub="Paid/Complete"
  //   "GroupUnPaidCount"         → group="Group",              sub="Unpaid/Incomplete"
  //   "PaidNationalCount"        → group="Paid/Complete",      sub="National"
  //   "UnPaidInternationalCount" → group="Unpaid/Incomplete",  sub="International"
  //   "PaidCount"                → group="Paid/Complete",      sub=""
  //   "OtherKey"                 → group="",                   sub="Other Key"
  parseColumn(key) {
    const stripped = key.replace(/Count$/i, "");

    const match = stripped.match(/^(.*?)(UnPaid|Paid)(.*)$/i);
    if (!match) {
      const label = stripped.replace(/([a-z])([A-Z])/g, "$1 $2").trim() || key;
      return { key, group: "", sub: label };
    }

    const [, before, paidType, after] = match;
    const isUnpaid = /unpaid/i.test(paidType);
    const paidLabel = isUnpaid ? "Unpaid/Incomplete" : "Paid/Complete";
    const spacedBefore = before.replace(/([a-z])([A-Z])/g, "$1 $2").trim();
    const spacedAfter = after.replace(/([a-z])([A-Z])/g, "$1 $2").trim();

    if (spacedBefore) {
      return { key, group: spacedBefore, sub: paidLabel };
    } else {
      return { key, group: paidLabel, sub: spacedAfter };
    }
  }

  // Generic table renderer.
  // Fixed 300px height with internal tbody scroll; thead sticks to top.
  // Totals row always computed from the full dataset.
  // totalKeys: optional subset of the numeric columns that should feed the "Total" column -
  // needed for tables like promo code wise, where one numeric column is a percentage and
  // summing it alongside a count column would be meaningless.
  renderTable(title, list, totalKeys) {
    const rows = Array.isArray(list) ? list : [];
    const allKeys = rows.length > 0 ? Object.keys(rows[0]) : [];

    const isNumericVal = (v) => v !== null && v !== "" && !isNaN(Number(v));
    const valueKeys = allKeys.filter((k) => isNumericVal(rows[0]?.[k]));
    const labelKeys = allKeys.filter((k) => !valueKeys.includes(k));
    // Matched loosely (case/spacing/"Count" suffix insensitive) so callers can pass a plain
    // label like "Visitor" without needing to know the exact backend column name.
    const normalizeKey = (s) => s.replace(/Count$/i, "").replace(/\s+/g, "").toLowerCase();
    const sumKeys =
      totalKeys && totalKeys.length
        ? valueKeys.filter((k) =>
            totalKeys.some((t) => normalizeKey(t) === normalizeKey(k)),
          )
        : valueKeys;

    const parsed = valueKeys.map((k) => this.parseColumn(k));
    const showTotal = valueKeys.length > 1;

    // Build consecutive group buckets for colSpan
    const groups = [];
    parsed.forEach((p) => {
      const last = groups[groups.length - 1];
      if (last && last.group === p.group) last.cols.push(p);
      else groups.push({ group: p.group, cols: [p] });
    });

    // Two-row header only when at least one group owns more than one column
    const needsTwoRows = groups.some((g) => g.group && g.cols.length > 1);

    const colSum = (k) =>
      rows.reduce((s, row) => s + (Number(row[k]) || 0), 0);
    const rowSum = (row) =>
      sumKeys.reduce((s, k) => s + (Number(row[k]) || 0), 0);
    const grandTotal = rows.reduce((s, row) => s + rowSum(row), 0);

    const totalCols = 1 + labelKeys.length + valueKeys.length + (showTotal ? 1 : 0);

    // Sticky th style — must have a background so rows don't bleed through on scroll
    const stickyTh = {
      position: "sticky",
      top: 0,
      zIndex: 2,
      backgroundColor: "#f8f9fa",
    };
    // Second header row sits below the first sticky row
    const stickyThRow2 = {
      position: "sticky",
      top: needsTwoRows ? "37px" : 0,
      zIndex: 2,
      backgroundColor: "#f8f9fa",
    };

    return (
      <div className="col-12 mb-4">
        {/* Fixed height wrapper — tbody scrolls, thead sticks */}
        <div style={{ maxHeight: "300px", overflowY: "auto", border: "1px solid #dee2e6" }}>
          <table className="table border text-nowrap text-md-nowrap table-bordered mb-0">
            <thead>
              {/* Full-width title row */}
              <tr>
                <th className="text-center" colSpan={totalCols} style={stickyTh}>
                  {title}
                </th>
              </tr>

              {needsTwoRows ? (
                <>
                  <tr>
                    <th className="text-center" rowSpan={2} style={stickyTh}>Sr No</th>
                    {labelKeys.map((k) => (
                      <th key={k} className="text-center" rowSpan={2} style={stickyTh}>{k}</th>
                    ))}
                    {groups.map((g, gi) =>
                      g.group ? (
                        <th key={gi} className="text-center" colSpan={g.cols.length} style={stickyTh}>
                          {g.group}
                        </th>
                      ) : (
                        g.cols.map((c) => (
                          <th key={c.key} className="text-center" rowSpan={2} style={stickyTh}>
                            {c.sub || c.key}
                          </th>
                        ))
                      ),
                    )}
                    {showTotal && (
                      <th className="text-center" rowSpan={2} style={stickyTh}>Total</th>
                    )}
                  </tr>
                  <tr>
                    {groups.map((g) =>
                      g.group
                        ? g.cols.map((c) => (
                            <th key={c.key} className="text-center" style={stickyThRow2}>
                              {c.sub || c.group}
                            </th>
                          ))
                        : null,
                    )}
                  </tr>
                </>
              ) : (
                <tr>
                  <th className="text-center" style={stickyTh}>Sr No</th>
                  {labelKeys.map((k) => (
                    <th key={k} className="text-center" style={stickyTh}>{k}</th>
                  ))}
                  {parsed.map((c) => (
                    <th key={c.key} className="text-center" style={stickyTh}>
                      {c.group || c.sub || c.key}
                    </th>
                  ))}
                  {showTotal && <th className="text-center" style={stickyTh}>Total</th>}
                </tr>
              )}
            </thead>

            <tbody>
              {rows.length > 0 ? (
                rows.map((row, i) => (
                  <tr key={i}>
                    <td className="text-center">{i + 1}</td>
                    {labelKeys.map((k) => (
                      <td key={k} className="text-center">{row[k]}</td>
                    ))}
                    {valueKeys.map((k) => (
                      <td key={k} className="text-center">{row[k]}</td>
                    ))}
                    {showTotal && (
                      <td className="text-center">
                        {rowSum(row)}
                      </td>
                    )}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={totalCols} style={{ textAlign: "center" }}>
                    Record not found
                  </td>
                </tr>
              )}
            </tbody>

            {/* Total row in tfoot so it sticks to the bottom of the scroll container */}
            {rows.length > 0 && (
              <tfoot>
                <tr style={{ position: "sticky", bottom: 0, backgroundColor: "#f8f9fa", zIndex: 2 }}>
                  <td className="text-center" colSpan={1 + labelKeys.length}>
                    Total
                  </td>
                  {valueKeys.map((k) => (
                    <td key={k} className="text-center">
                      {colSum(k)}
                    </td>
                  ))}
                  {showTotal && (
                    <td className="text-center">
                      {grandTotal}
                    </td>
                  )}
                </tr>
              </tfoot>
            )}
          </table>
        </div>
      </div>
    );
  }

  render() {
    const {
      isLoading,
      categoryWise,
      singleAndGroupWise,
      dayWise,
      countryWise,
      top5IndianStates,
      top10IndianCity,
      purposeOfVisit,
      purposeOfSegment,promoCodeWise
    } = this.state;

    return (
      <>
        {isLoading ? <Loader></Loader> : null}
        <ToastContainer />
        <HeaderWithLogo />
        <>
          <AdminDrawer />
          <div className="admin-top-space">
            <div className="row mt-2 m-0">
              {this.renderTable(
                "India ITME 2026  Category wise Visitor Registration  Summary as on date",
                categoryWise,
              )}
              {this.renderTable(
                "India ITME 2026  Single/Group Wise Visitor Summary as on date",
                singleAndGroupWise,
              )}
              {this.renderTable(
                "India ITME 2026  Day Wise  Visitor Summary as on date",
                dayWise,
              )}
              {this.renderTable(
                "India ITME 2026  Country wise Visitor Summary as on date",
                countryWise,
              )}
              {this.renderTable(
                "India ITME 2026  Top 5 Indian States wise Visitor Registration  Summary as on date",
                top5IndianStates,
              )}
              {this.renderTable(
                "India ITME 2026  Top 10  Indian City wise  Visitor Registration  Summary as on date",
                top10IndianCity,
              )}
              {this.renderTable(
                "India ITME 2026  Purpose of Visit wise Visitor Registration  Summary as on date",
                purposeOfVisit,
              )}
              {this.renderTable(
                "India ITME 2026  Segment wise Visitor Registration  Summary as on date",
                purposeOfSegment,
              )}
              {this.renderTable(
                "India ITME 2026 Promo code wise Visitor Registration Summary as on date",
                promoCodeWise,
                ["Visitor"],
              )}
            </div>
          </div>
        </>
      </>
    );
  }
}

export default withRouter(
  connect(null, {
    getAdminVisitorSummaryList_action,
  })(VisitorSummary),
);
